interface CredibilityMeterProps {
  value: number;
  label?: string;
  className?: string;
}

export default function CredibilityMeter({ value, label = "可信度", className = "" }: CredibilityMeterProps) {
  const segments = 10;
  const filled = Math.round(value / 10);

  return (
    <div className={className}>
      <div className="flex items-center justify-between mb-1.5">
        <span className="font-label text-[11px] uppercase tracking-widest text-foreground-500">{label}</span>
        <span className="font-label text-sm font-bold text-foreground-950">{value}<span className="text-foreground-400">/100</span></span>
      </div>
      <div className="flex gap-1" role="img" aria-label={`${label} ${value} 分，满分 100 分`}>
        {Array.from({ length: segments }).map((_, index) => (
          <span
            key={index}
            className={`h-1.5 flex-1 rounded-full ${
              index < filled
                ? value >= 75
                  ? "bg-primary-500"
                  : value >= 50
                    ? "bg-accent-500"
                    : "bg-foreground-300"
                : "bg-background-200"
            }`}
          />
        ))}
      </div>
    </div>
  );
}